export default {
    'searchList': {
        'searchTxt': [{
            'name': '运输单号',
            'value': 'ettaNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '客户订单号',
            'value': 'ettaSoNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '发车单号',
            'value': 'etdoNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }, {
            'name': '发车单状态',
            'value': 'etdoStatus',
            'type': 'select',
            'span': 3,
            'optionNum': 'SYS_TRANSPORT_DO_STATUS',
            'unfold': true,
            'multiple': false
        }, {
            'name': '创建时间',
            'value': 'createTime',
            'startTime': 'createTimeFrom',
            'endTime': 'createTimeTo',
            'startPlaceholder': '创建开始日期',
            'endPlaceholder': '创建结束日期',
            'type': 'time',
            'timeNum': 30,
            'unfold': true,
            'span': 6
        }],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table':
    {
        'leftWidth': 80,
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'columns': [
            {
                'label': '发车单号',
                'prop': 'etdoNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '发车单状态',
                'prop': 'etdoStatusType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '要求到货时间',
                'prop': 'ettaReqArrivalDate',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '当前延迟天数',
                'prop': 'ettaIsReturnTask',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '线路',
                'prop': 'etdoLineName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '采购渠道',
                'prop': 'etdoProcurementChannelType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '承运商',
                'prop': 'etdoCarrierName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '车型',
                'prop': 'etdoEquipmentName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '车牌号',
                'prop': 'etdoVehicleCard',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '司机',
                'prop': 'etdoMainDriver',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '最后跟踪时间',
                'prop': 'etisDate',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '最后跟踪地点',
                'prop': 'etisLocation',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '联系方式',
                'prop': 'etdoMainDriverContactWay',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '客户',
                'prop': 'ettaCustomEbcuNameCn',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '分公司',
                'prop': 'companyName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '体积',
                'prop': 'etdoVolume',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '重量',
                'prop': 'etdoTotalGrossWeight',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '数量',
                'prop': 'etdoTotalQty',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '实际发货数量',
                'prop': 'etdoTotalEa',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '发车时间',
                'prop': 'etdoDepartDate',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '收货单位',
                'prop': 'ettaConsigneeEbspNameCn',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '直通宝标识',
                'prop': 'etdoLtlFlagType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '预计到货时间',
                'prop': 'etdoBesArriveDate',
                'sort': true,
                'width': '148px'
            }],
        'action': [
            {
                'type': 'text',
                'label': '到达',
                'size': 'mini',
                'event': 'arrive',
                'ifHas': '05040104'
            }
        ],
        'leftOperation': true
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100] // eslint-disable-line
    },
    'searchTotalTitle': [
        {
            'name': '集拼号',
            'value': 'ettaAssighNo',
            'type': 'input',
            'span': 3
        }, {
            'name': '客户',
            'value': 'ebcuNameCn',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'ebcuNameCn', 'value': '客户名称' },
                { 'prop': 'pmCode', 'value': '客户编码' }
            ],
            'tableConfig': [
                { 'prop': 'pmCode', 'value': '客户编码' },
                { 'prop': 'ebcuNameCn', 'value': '客户名称' }
            ],
            'advanceUrl': '/ebCustomer/searchByEbCustomer',
            'cbParams': ['pmCode#ettaCustomEbcuNo', 'ebcuNameCn'],
            'span': 4
        }, {
            'name': '车牌号',
            'value': 'etdoVehicleCard',
            'unfold': true,
            'advanceConfig': [
                { 'prop': 'licensePlateNumber', 'value': '车牌' },
                { 'prop': 'cargoVolumeStr', 'value': '载货体积' },
                { 'prop': 'cdegNameCn', 'value': '车型' }
            ],
            'tableConfig': [
                { 'prop': 'licensePlateNumber', 'value': '车牌' },
                { 'prop': 'cargoVolume', 'value': '载货体积' },
                { 'prop': 'cdegNameCn', 'value': '车型' }
            ],
            'advanceUrl': 'suCar/searchByConditions',
            'cbParams': [
                'licensePlateNumber#etdoVehicleCard', 'cdegNameCn#etdoEquipmentName', 'etveType#etdoEquipmentType'
            ],
            'type': 'advance',
            'advanceCascade': 'carrierCode#suppliersCode'
        }, {
            'name': '今日是否已跟踪',
            'value': 'isTracking',
            'type': 'select',
            'span': 3,
            'optionNum': 'SYS_SUPPLIER_YES_NO',
            'multiple': false
        }, {
            'name': '线路',
            'value': 'eblnLineName',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'eblnLineCode', 'value': '代码' },
                { 'prop': 'eblnLineName', 'value': '名称' }
            ],
            'tableConfig': [
                { 'prop': 'eblnLineCode', 'value': '代码' },
                { 'prop': 'eblnLineName', 'value': '名称' },
                { 'prop': 'eblnRatedMileage', 'value': '额定里程' }
            ],
            'advanceUrl': '/ebLine/search',
            'cbParams': ['eblnLineCode#etdoLineCode', 'eblnLineName', 'eblnRatedMileage'],
            'span': 4
        }, {
            'name': '物流订单号',
            'value': 'ettaOrderNo',
            'type': 'input',
            'span': 3
        }, {
            'name': '直通宝标识',
            'value': 'etdoLtlFlag',
            'type': 'select',
            'span': 3,
            'optionNum': 'SYS_TMS_ZTB_FLAG',
            'multiple': false
        }
    ]
};
